/* ============================================================
   PHREE SKIN — theme UI engines (ported from the static site's app.js).
   Runs on the storefront AND re-inits on the theme editor's
   shopify:section:load so bands keep working when re-rendered.
   Owns: announce ticker · the Braille "gift" slogan · hero/film video.
   (Cart lives in cart.js; dot-fields in dots.js; scroll motion in motion.js;
    the microbiome scrub in balance.js.)
   ============================================================ */
(function () {
  "use strict";
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- announce bar: one message at a time (single line) ---------- */
  /* THE ANNOUNCEMENT ROTATOR LIVES IN sections/announcement.liquid, NOT HERE.
     This used to run a SECOND rotator on its own 4s interval, doing the swap in a
     single tick:  remove is-on from the current item, add it to the next. Both
     then ran their .4s opacity transition at once and, because the items are
     absolutely stacked at inset:0, two different sentences painted over each
     other every handoff. The section's own script does the same job correctly —
     it fades the outgoing message out, WAITS for that transition to finish, and
     only then fades the next one in — but the two intervals raced and this one
     won often enough that the overlap survived every attempt to fix it in the
     section. Measured on the live site: at handoff, opacity 0.78 on the outgoing
     message while the incoming already carried .is-on.

     One rotator, in the section that owns the markup and the speed setting. */
  function announceTicker() {}

  /* ---------- hero + film-band videos: pick rendition, autoplay muted+slow ---------- */
  function heroVideos(root) {
    [].slice.call((root || document).querySelectorAll("video[data-hero-video]")).forEach(function (v) {
      var small = matchMedia("(max-width:640px)").matches;
      var src = (small && v.dataset.srcMobile) ? v.dataset.srcMobile : (v.dataset.srcDesktop || v.dataset.srcMobile);
      if (src && !v.getAttribute("src")) { v.setAttribute("src", src); try { v.load(); } catch (e) {} }
      var rate = function () { try { v.playbackRate = 0.72; } catch (e) {} };
      var play = function () { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); };
      rate(); play();
      v.addEventListener("loadedmetadata", rate);
      v.addEventListener("canplay", play);
    });
  }

  /* ---------- the GIFT: slogan spelled in a dense Braille dot-field ---------- */
  function giftSlogan(root) {
    /* FIND THE CANVAS, NOT A HARD-CODED id.
       This used to look for `#gift`. On the standalone site the section really
       was id="gift", but as a Shopify section it renders id="gift-{{ section.id }}"
       so two copies of the section cannot collide — which means #gift matches
       nothing, host came back null, and this returned on its first line.

       The canvas was therefore never sized (it sat at the default 300x150) and
       never painted, so the block that closes EVERY page on the site rendered as
       320px of flat empty near-black below the footer. Selecting on the canvas
       and walking up to its section is robust to the namespaced id. */
    var scope = (root && root.querySelectorAll) ? root : document;
    var cv = scope.querySelector("canvas[data-slogan]") || document.querySelector("canvas[data-slogan]");
    if (!cv) return;
    var host = cv.closest(".gift") || cv.parentElement;
    if (!host) return;
    if (cv.__gift) return; cv.__gift = true;
    var ctx = cv.getContext("2d");
    var DPR = Math.min(2, window.devicePixelRatio || 1);
    var SKY = [115, 179, 206], SKYL = [168, 208, 226];
    var dots = [], running = false, t0 = 0, DUR = 1750, revealed = false;
    function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function txt() { return document.documentElement.lang === "en" ? (cv.getAttribute("data-en") || cv.getAttribute("data-text") || "") : (cv.getAttribute("data-text") || ""); }
    function lines() {
      var w = txt().split(/\s+/).filter(Boolean);
      if (w.length <= 1) return [w.join(" ")];
      var mid = Math.ceil(w.length / 2);
      return [w.slice(0, mid).join(" "), w.slice(mid).join(" ")];
    }
    function build() {
      var W = host.clientWidth, H = host.clientHeight;
      if (W < 10 || H < 10) return;
      cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
      cv.style.width = W + "px"; cv.style.height = H + "px";
      var off = document.createElement("canvas"); off.width = W; off.height = H;
      var o = off.getContext("2d");
      o.textAlign = "center"; o.textBaseline = "middle"; o.fillStyle = "#fff";
      var ls = lines(), target = W * 0.9, maxH = H * 0.8, fs = Math.min(H * 0.52, W * 0.22);
      for (var k = 0; k < 46; k++) {
        o.font = "700 " + fs + 'px "Stolzl", system-ui, sans-serif';
        var widest = 0; ls.forEach(function (l) { widest = Math.max(widest, o.measureText(l).width); });
        if (widest <= target && ls.length * fs * 1.08 <= maxH) break;
        fs *= 0.93;
      }
      o.font = "700 " + fs + 'px "Stolzl", system-ui, sans-serif';
      var lh = fs * 1.08, y0 = H / 2 - (ls.length - 1) * lh / 2;
      ls.forEach(function (l, i) { o.fillText(l, W / 2, y0 + i * lh); });
      var pitch = Math.max(5, Math.round(fs / 12));
      var data = o.getImageData(0, 0, W, H).data;
      dots = [];
      for (var y = (pitch >> 1); y < H; y += pitch)
        for (var x = (pitch >> 1); x < W; x += pitch)
          if (data[(y * W + x) * 4 + 3] > 100) dots.push({ x: x, y: y, d: x / W });
      draw(reduce ? 1 : (revealed ? 1 : 0));
    }
    function draw(p) {
      var W = host.clientWidth, H = host.clientHeight;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0); ctx.clearRect(0, 0, W, H);
      var dotR = Math.max(1.3, Math.min(3, W / 470));
      for (var i = 0; i < dots.length; i++) {
        var dt = dots[i], lp = clamp01((p - dt.d * 0.55) / 0.45);
        if (lp <= 0) continue;
        var e = lp < 1 ? 1 - Math.pow(1 - lp, 3) : 1;
        var c = (i % 6 === 0) ? SKYL : SKY;
        ctx.fillStyle = "rgba(" + c[0] + "," + c[1] + "," + c[2] + "," + (0.9 * e).toFixed(3) + ")";
        ctx.beginPath(); ctx.arc(dt.x, dt.y, dotR * (0.35 + 0.65 * e), 0, 6.28319); ctx.fill();
      }
    }
    function step(now) { if (!t0) t0 = now; var p = clamp01((now - t0) / DUR); draw(p); if (p < 1) requestAnimationFrame(step); else running = false; }
    function play() { if (reduce) { draw(1); return; } if (running) return; running = true; t0 = 0; requestAnimationFrame(step); }
    build();
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !revealed) { revealed = true; play(); } }); }, { threshold: 0.3 }).observe(host);
    var rt; window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(build, 180); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
  }

  /* ---------- Shopify-captcha-safe /contact POST (hidden iframe, no fetch) ----------
     Shopify auto-wires hCaptcha bot-protection onto any form whose action contains
     "/contact" and carries a form_type=customer|contact hidden field (exactly what the
     {% form 'customer' %} Liquid tag emits). A synthetic FormData + fetch() never gets a
     captcha token attached and is rejected with "Missing CAPTCHA token". The documented
     fix is a real <form> element run through window.Shopify.captcha.protect(form, cb),
     submitted via a hidden iframe target so the page never navigates away. */
  function submitContactForm(fields) {
    var IFRAME_NAME = "ph-contact-frame";
    var iframe = document.getElementsByName(IFRAME_NAME)[0];
    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.name = IFRAME_NAME;
      iframe.hidden = true;
      iframe.style.display = "none";
      document.body.appendChild(iframe);
    }
    var f = document.createElement("form");
    f.action = "/contact";
    f.method = "post";
    f.acceptCharset = "UTF-8";
    f.target = IFRAME_NAME;
    f.hidden = true;
    f.style.display = "none";
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = fields[name];
      f.appendChild(input);
    });
    document.body.appendChild(f);

    function doSubmit() {
      try { f.submit(); } catch (e) {}
      window.setTimeout(function () { f.parentNode && f.parentNode.removeChild(f); }, 1000);
    }

    try {
      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === "function") {
        window.Shopify.captcha.protect(f, doSubmit);
      } else {
        doSubmit();
      }
    } catch (e) { doSubmit(); }
  }

  /* ---------- popups: render the owner's "Popup" metaobjects ---------- */
  var popupsInit = false;
  function initPopups() {
    if (popupsInit) return; popupsInit = true;
    var host = document.getElementById("ph-popups"); if (!host) return;
    /* NEVER INTERRUPT THE BUY MODULE.
       The welcome popup opened over the product page and covered the entire
       buy box — price, plan picker, quantity and the add-to-cart button. A
       visitor on a product page is already doing the thing the popup exists to
       start, so it taxes the sale rather than winning one, and it puts "15% off
       your first order" directly on top of "save 25% with a subscription",
       which is exactly the discount confusion the two offers already risk.
       The popup still works everywhere else; on a product page the visitor
       reaches the same offer through the footer signup. */
    var onProduct = document.body.classList.contains("template-product");
    [].slice.call(host.querySelectorAll("[data-popup]")).forEach(function (pop) {
      if (onProduct) return;
      var key = pop.getAttribute("data-key");
      var once = pop.getAttribute("data-once") === "true";
      if (once) { try { if (localStorage.getItem(key)) return; } catch (e) {} }
      var trigger = pop.getAttribute("data-trigger") || "timed";
      var delay = parseInt(pop.getAttribute("data-delay") || "8", 10);
      var opened = false;
      function open() {
        if (opened) return; opened = true;
        pop.hidden = false; document.body.classList.add("phpop-lock");
        requestAnimationFrame(function () { pop.classList.add("is-open"); });
        if (once) { try { localStorage.setItem(key, "1"); } catch (e) {} }
      }
      function close() {
        pop.classList.remove("is-open"); document.body.classList.remove("phpop-lock");
        setTimeout(function () { pop.hidden = true; }, 320);
      }
      if (trigger === "exit") {
        document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
      } else if (trigger === "scroll") {
        var onScroll = function () { if (window.scrollY > window.innerHeight * 0.6) { open(); window.removeEventListener("scroll", onScroll); } };
        window.addEventListener("scroll", onScroll, { passive: true });
      } else {
        setTimeout(open, Math.max(0, delay) * 1000);
      }
      [].slice.call(pop.querySelectorAll("[data-popup-close]")).forEach(function (b) { b.addEventListener("click", close); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && pop.classList.contains("is-open")) close(); });
      var form = pop.querySelector("[data-popup-form]");
      if (form) form.addEventListener("submit", function (e) {
        e.preventDefault();
        var input = form.querySelector('input[name="email"]');
        submitContactForm({
          form_type: "customer",
          utf8: "✓",
          "contact[email]": input ? input.value : "",
          "contact[tags]": "newsletter"
        });
        form.hidden = true;
        var done = pop.querySelector("[data-popup-done]"); if (done) done.hidden = false;
      });
    });
  }

  function initAll(root) { announceTicker(root); heroVideos(root); giftSlogan(root); initPopups(); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  else initAll(document);

  /* editor-safe: re-init a section when the theme editor re-renders it */
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
